import React from 'react'
import './fix.css'



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
export default function FIX() {
  return (
 <>
 
 
 
 
 
 
 <section id="fixed-btn">



   <a href="tel:+919944210143" className="fixed-button call" title="Call Now">
          <FontAwesomeIcon icon={faPhone} />
        </a>
        <a href="https://wa.me/919944210143" className="fixed-button whatsapp" target="_blank" rel="noopener noreferrer" title="Chat on WhatsApp">
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>

 </section>
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 </>
  )
}
